/**
 * Mega menu menu_product_2: switch right-hand product panels when
 * hovering/focusing left category links ([data-mp2] + .mp2-panels).
 */
(function () {
  if (window.__boyaMp2MenuInit) return;
  window.__boyaMp2MenuInit = true;

  var DESKTOP_MQ = "(min-width: 1025px)";
  var MOBILE_PANEL_SELECTOR = [
    ".mobile_menu-level2-container",
    ".mobile_menu-level2-container-mega",
    ".mobile_menu-level3-container",
    ".mobile_menu-mega-product-level3-container",
  ].join(",");
  var MOBILE_MOTION_MS = 240;
  var MOBILE_MOTION_OFFSET = 12;

  function findDisclosurePanel(row) {
    if (!row) return null;

    var sibling = row.nextElementSibling;
    while (sibling) {
      if (sibling.matches && sibling.matches(MOBILE_PANEL_SELECTOR)) return sibling;
      sibling = sibling.nextElementSibling;
    }

    return null;
  }

  function setDisclosureState(row, expanded) {
    var link = row && row.querySelector ? row.querySelector(":scope > a") : null;
    if (link) link.setAttribute("aria-expanded", expanded ? "true" : "false");
  }

  function toggleMobileDisclosure(row, forceOpen) {
    if (!row) return false;

    var panel = findDisclosurePanel(row);
    var currentlyOpen =
      row.classList.contains("is-open") && row.getAttribute("data-menu-closing") !== "true";
    var opening = typeof forceOpen === "boolean" ? forceOpen : !currentlyOpen;

    setDisclosureState(row, opening);

    if (!panel || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      row.classList.toggle("is-open", opening);
      row.removeAttribute("data-menu-closing");
      return opening;
    }

    var token = String((Number(panel.getAttribute("data-menu-motion-token")) || 0) + 1);
    panel.setAttribute("data-menu-motion-token", token);
    panel.classList.add("mobile-menu-panel-motion");
    panel.style.overflow = "hidden";
    panel.style.willChange = "height, opacity, transform";

    if (opening) {
      row.removeAttribute("data-menu-closing");
      row.classList.add("is-open");
      panel.style.height = "0px";
      panel.style.opacity = "0";
      panel.style.transform = "translate3d(0, -" + MOBILE_MOTION_OFFSET + "px, 0)";
      panel.style.visibility = "visible";
      panel.classList.remove("is-expanded");
      void panel.offsetHeight;
      panel.classList.add("is-expanded");
      panel.style.height = panel.scrollHeight + "px";
      panel.style.opacity = "1";
      panel.style.transform = "translate3d(0, 0, 0)";
    } else {
      row.setAttribute("data-menu-closing", "true");
      panel.style.height = panel.getBoundingClientRect().height + "px";
      panel.style.opacity = "1";
      panel.style.transform = "translate3d(0, 0, 0)";
      panel.style.visibility = "visible";
      panel.classList.add("is-expanded");
      void panel.offsetHeight;
      panel.classList.remove("is-expanded");
      panel.style.height = "0px";
      panel.style.opacity = "0";
      panel.style.transform = "translate3d(0, -" + MOBILE_MOTION_OFFSET + "px, 0)";
    }

    window.setTimeout(function () {
      if (panel.getAttribute("data-menu-motion-token") !== token) return;

      if (opening) {
        panel.style.height = "auto";
        panel.style.overflow = "visible";
        panel.style.opacity = "1";
        panel.style.transform = "translate3d(0, 0, 0)";
        panel.style.visibility = "visible";
      } else {
        row.classList.remove("is-open");
        row.removeAttribute("data-menu-closing");
        panel.style.height = "0px";
        panel.style.opacity = "0";
        panel.style.transform = "translate3d(0, -" + MOBILE_MOTION_OFFSET + "px, 0)";
        panel.style.visibility = "hidden";
      }
      panel.style.willChange = "auto";
    }, MOBILE_MOTION_MS + 40);

    return opening;
  }

  window.BoyaMenuDisclosure = window.BoyaMenuDisclosure || {};
  window.BoyaMenuDisclosure.findPanel = findDisclosurePanel;
  window.BoyaMenuDisclosure.toggle = toggleMobileDisclosure;

  function hydrateImage(image) {
    if (!image || (!image.hasAttribute("data-src") && !image.hasAttribute("data-srcset"))) return;

    image.addEventListener(
      "load",
      function () {
        image.classList.remove("bls-loading-image");
      },
      { once: true }
    );

    var picture = image.closest("picture");
    if (picture) {
      picture.querySelectorAll("source[data-srcset]").forEach(function (source) {
        source.setAttribute("srcset", source.getAttribute("data-srcset"));
        source.removeAttribute("data-srcset");
      });
    }

    if (image.hasAttribute("data-srcset")) {
      image.setAttribute("srcset", image.getAttribute("data-srcset"));
      image.removeAttribute("data-srcset");
    }
    if (image.hasAttribute("data-src")) {
      image.setAttribute("src", image.getAttribute("data-src"));
      image.removeAttribute("data-src");
    }
    image.setAttribute("data-deferred-image", "false");
  }

  function hydratePanel(panel) {
    if (!panel || panel.getAttribute("data-mp2-images-ready") === "true") return;
    panel.querySelectorAll("img[data-src], img[data-srcset]").forEach(hydrateImage);
    panel.setAttribute("data-mp2-images-ready", "true");
  }

  function hydrateKey(root, key) {
    if (!key) return;
    root
      .querySelectorAll(".mp2-panel[data-key], .mobile_menu-mega-product-level3-container[data-key]")
      .forEach(function (candidate) {
      if (candidate.getAttribute("data-key") === key) hydratePanel(candidate);
      });
  }

  function hasPanelForKey(root, key) {
    if (!key) return false;
    return Array.prototype.some.call(
      root.querySelectorAll(
        ".mp2-panel[data-key], .mobile_menu-mega-product-level3-container[data-key]"
      ),
      function (panel) {
        return panel.getAttribute("data-key") === key;
      }
    );
  }

  function activate(root, key) {
    if (!key) return;
    var links = root.querySelectorAll(".mp2-link[data-key]");
    var panels = root.querySelectorAll(".mp2-panel[data-key]");
    var matched = false;

    panels.forEach(function (panel) {
      var on = panel.getAttribute("data-key") === key;
      if (on) matched = true;
      panel.classList.toggle("hidden", !on);
      if (on) hydratePanel(panel);
    });

    if (!matched) return;

    links.forEach(function (link) {
      var on = link.getAttribute("data-key") === key;
      link.classList.toggle("active", on);
      link.setAttribute("aria-selected", on ? "true" : "false");
    });
  }

  function bindRoot(root) {
    if (!root || root.getAttribute("data-mp2-bound") === "true") return;
    var panelsWrap = root.querySelector(".mp2-panels");
    root.setAttribute("data-mp2-bound", "true");
    var links = root.querySelectorAll(".mp2-link[data-key]");

    function hydrateVisiblePanel() {
      if (!panelsWrap) return;
      var visiblePanel = panelsWrap.querySelector(".mp2-panel:not(.hidden)");
      if (visiblePanel) hydratePanel(visiblePanel);
    }

    root.addEventListener("mouseenter", hydrateVisiblePanel, { once: true });
    root.addEventListener("mp2:open", hydrateVisiblePanel);

    function findLink(target) {
      if (!target || !target.closest) return null;
      var link = target.closest(".mp2-link[data-key]");
      if (!link) {
        var mobileRow = target.closest(".mobile_menu-mega-product-level2");
        if (mobileRow) link = mobileRow.querySelector(".mp2-link[data-key]");
      }
      return link && root.contains(link) ? link : null;
    }

    // One delegated handler replaces per-link listeners and also hydrates mobile panels.
    root.addEventListener(
      "click",
      function (event) {
        var link = findLink(event.target);
        if (!link) return;

        var key = link.getAttribute("data-key");
        var mobileRow = link.closest(".mobile_menu-mega-product-level2");
        var mobilePanel = mobileRow ? findDisclosurePanel(mobileRow) : null;
        var hasPanel = Boolean(mobilePanel) || hasPanelForKey(root, key);
        if (!hasPanel) {
          if (
            mobileRow &&
            event.target !== link &&
            !link.contains(event.target) &&
            !(event.target.closest && event.target.closest("open-children-toggle"))
          ) {
            link.click();
          }
          return;
        }

        hydrateKey(root, key);
        var desktop = window.matchMedia(DESKTOP_MQ).matches;

        // Mobile MP2 rows always control their adjacent product panel. Keep this
        // independent of the desktop panel wrapper so every point in the row works.
        if (!desktop && mobileRow) {
          event.preventDefault();
          if (!event.target.closest("open-children-toggle")) {
            var expanded = toggleMobileDisclosure(mobileRow);
            link.setAttribute("aria-expanded", expanded ? "true" : "false");
          }
          return;
        }

        if (!panelsWrap) return;

        // Level-2 categories control product panels; only product cards and CTA links navigate.
        event.preventDefault();
        if (desktop) {
          activate(root, key);
          return;
        }

        if (!link.classList.contains("active")) {
          event.preventDefault();
          activate(root, key);
        }
      },
      true
    );

    if (!panelsWrap) return;

    root.addEventListener("mouseover", function (event) {
      var link = findLink(event.target);
      if (!link || (event.relatedTarget && link.contains(event.relatedTarget))) return;
      activate(root, link.getAttribute("data-key"));
    });

    root.addEventListener("focusin", function (event) {
      var link = findLink(event.target);
      if (link) {
        activate(root, link.getAttribute("data-key"));
      } else {
        hydrateVisiblePanel();
      }
    });
  }

  function scan(scope) {
    (scope || document).querySelectorAll("[data-mp2]").forEach(bindRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    scan(event && event.target ? event.target : document);
  });
})();
